<section #root
    class="content-section relative z-10 w-full px-4 sm:px-8 py-[clamp(24px,4vw,56px)]"
    [class.align-left]="align === 'left'"
    [class.align-right]="align === 'right'"
    [class.reveal-ready]="revealReady()"
    [class.is-visible]="revealed()">
    <div class="cs-inner mx-auto flex w-full max-w-[1100px] flex-col">
        <h2 class="reveal cs-heading font-outfit font-semibold" style="--reveal-delay:0ms"
            [innerHTML]="section.headingHtml"></h2>
        <span class="reveal cs-keyline" style="--reveal-delay:80ms" aria-hidden="true"></span>

        <div class="reveal cs-prose font-inter space-y-4" style="--reveal-delay:140ms">
            @for (paragraph of section.lead; track $index) {
                <p>{{ paragraph }}</p>
            }
        </div>

        @if (section.bullets?.length) {
            <ul class="reveal cs-grid mt-8 grid w-full gap-3 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
                style="--reveal-delay:200ms">
                @for (bullet of section.bullets; track $index) {
                    <li class="cs-chip">
                        <img class="cs-check" src="images/shared/check.svg" alt="" aria-hidden="true" loading="lazy" />
                        <span>{{ bullet }}</span>
                    </li>
                }
            </ul>
        }

        @if (section.steps?.length) {
            <ul class="reveal mt-8 w-full space-y-4" style="--reveal-delay:200ms">
                @for (step of section.steps; track $index) {
                    <li class="cs-step">
                        <span class="font-semibold gradient-text">{{ step.term }}</span>
                        <span class="block">{{ step.detail }}</span>
                    </li>
                }
            </ul>
        }

        @if (section.outro?.length) {
            <div class="reveal cs-prose font-inter space-y-4 mt-6" style="--reveal-delay:260ms">
                @for (paragraph of section.outro; track $index) {
                    <p>{{ paragraph }}</p>
                }
            </div>
        }
    </div>
</section>
